<div class="card card--no-padding">
  <div class="kpi-table">
    <header class="kpi-table__header">{{ title() }}</header>
    <div class="kpi-table__row">
      <div class="kpi-table__col"></div>
      @for (item of kpiItems(); track $index) {
        <div class="kpi-table__col" [matTooltip]="getHeaderTooltip(item)" [matTooltipPosition]="'above'">
          <h4 class="truncate">KPI {{ $index + 1 }}</h4>
          <div class="truncate kpi-table__subtitle">{{ item.name | translate }}</div>
          @if (item.unit) {
            <div class="kpi-table__unit">({{ item.unit }})</div>
          }
        </div>
      }
    </div>
    @if (allRowsEmpty()) {
      <div class="kpi-table__empty-body">
        <div class="kpi-table__empty-periods">
          @for (row of kpiRows(); track $index) {
            <div class="kpi-table__col">
              <div class="truncate">{{ row.days | kpiDaysKey | translate }}</div>
            </div>
          }
        </div>
        <div class="kpi-table__col kpi-table__col--empty kpi-table__col--empty-merged" [style.flex]="kpiItems().length">
          {{ "Wireless.KPI.NoDataAvailableToShow" | translate }}
        </div>
      </div>
    } @else {
      @for (row of kpiRows(); track $index) {
        <div class="kpi-table__row">
          <div class="kpi-table__col">
            <div class="truncate">{{ row.days | kpiDaysKey | translate }}</div>
          </div>
          @for (col of row.values; track $index) {
            <div class="kpi-table__col kpi-table__col--{{ getStatus(col.value, col.kpi.danger, col.kpi.warning) }}">
              {{ col.value !== undefined ? (col.value | number: "1.1-1") : "?" }}
              @if (col.kpi.unit === "%" && col.value !== undefined) {
                <span>%</span>
              }
            </div>
          }
        </div>
      }
    }
  </div>
</div>
